import react from "react";
import { Link } from "react-router-dom";
import { Plus, Minus, ShoppingCart } from "lucide-react";

const placeholder = new URL(
  "../../../../assets/placeholder.png",
  import.meta.url,
).href;

export default function CartItems({
  cartItems,
  user,
  onUpdateQuantity,
  onRemoveItem,
}) {
  if (!Array.isArray(cartItems) || cartItems.length === 0) {
    return (
      <div className="kn-card p-8 text-center">
        <div className="flex justify-center mb-4">
          <ShoppingCart className="h-12 w-12 text-knapp-accent" />
        </div>
        <h2 className="kn-h3 mb-2">Ihr Warenkorb ist leer</h2>
        <p className="kn-body mb-6">
          Stöbern Sie in unseren Produkten und legen Sie etwas in den Warenkorb.
        </p>
        <Link to="/produkte" className="kn-btn-primary">
          Zu den Produkten
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3.5">
      {cartItems.map((item) => {
        const einzelpreis = Number(item.Preis_brutto);
        const zeilensumme = einzelpreis * item.menge;
        const productId = item.product_id || item.idProdukt;
        return (
          <article
            key={productId}
            className="flex items-center gap-4 flex-wrap kn-card p-4"
          >
            <img
              src={item.Bild || placeholder}
              alt={item.Name}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = placeholder;
              }}
              className="h-[92px] w-[92px] shrink-0 object-contain rounded-[10px] border border-knapp-borderSubtle bg-knapp-surface p-1"
            />

            <div className="flex-1 min-w-[180px]">
              <div className="text-[17px] font-semibold leading-tight text-knapp-ink lg:break-words">
                {item.Name}
              </div>
              <div className="text-sm text-knapp-ink3 mt-1">
                Einzelpreis CHF {einzelpreis.toFixed(2)}
              </div>
            </div>

            <div className="kn-qty">
              <button
                onClick={() => onUpdateQuantity(productId, item.menge - 1)}
                className="kn-qty-btn w-[38px] h-[42px] text-lg"
                aria-label="Menge verringern"
              >
                <Minus className="h-4 w-4" />
              </button>
              <span className="w-[30px] text-center text-base font-semibold">
                {item.menge}
              </span>
              <button
                onClick={() => onUpdateQuantity(productId, item.menge + 1)}
                className="kn-qty-btn w-[38px] h-[42px] text-lg"
                aria-label="Menge erhöhen"
              >
                <Plus className="h-4 w-4" />
              </button>
            </div>

            <div className="min-w-[110px] text-right text-lg font-bold text-knapp-accent whitespace-nowrap">
              CHF {zeilensumme.toFixed(2)}
            </div>

            <button
              type="button"
              onClick={() => onRemoveItem(item)}
              className="border-0 bg-transparent text-sm text-knapp-ink4 underline cursor-pointer hover:text-knapp-accent"
            >
              Entfernen
            </button>
          </article>
        );
      })}
    </div>
  );
}
